
const userprofile = [{"key":"userprofile.title","string":"Váš profil pro žluté stránky"},{"key":"userprofile.button.update_profile","string":"Aktualizovat profil"},{"key":"userprofile.no_profile","string":"Zatím jste na žluté stránky nepřidal žádný profil. "}]

export default userprofile



// WEBPACK FOOTER //
// ./src/i18n/cs/adduserprofile/userprofile.js